import React from "react";
import { Link } from "react-router-dom";
import * as CHQ from "chq";
import { DefaultProfile } from "app/context/ProfileContext";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type TemplateDoneNotificationProps = {
  notification: CHQ.NotificationTemplateDone;
  profile?: CHQ.Profile | DefaultProfile;
  tabIndex?: number;
};

const TemplateDoneNotification: React.FC<TemplateDoneNotificationProps> = ({
  notification: { entity }, profile, tabIndex
}) => (
  <NotificationBody actor={profile as CHQ.Creator}>
    <Trans>Your template:</Trans>
    {" "}
    <Link to="/admin/templates">
      {(entity as CHQ.Template)?.name}
    </Link>
    {" "}
    <Trans>was updated successfully</Trans>
  </NotificationBody>
);

export default TemplateDoneNotification;
